/**
 * 用户相关工具类
 */
import { getUserInfoFromCookie } from './util/user-info'

class User{
    // 用户是否登录
    static isLogin(){
        return getUserInfoFromCookie("loginId") != ""
    }
}

export {
    User
}


// WEBPACK FOOTER //
// ./src/lib/user.js